// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-07-16T10:45:01+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  188861
//    Project:        608
//    Environment:    7352 - master
//    MD5:            5b5c4fedc1cf68664eb00dadf5bd8ed3
//    Signature:      eyJpdiI6IlNrbXhNUHJzbjFXTU1IZiszeFwvcWZBPT0iLCJ2YWx1ZSI6Ilh1bnRlZ0pzc1dXczlFUWRFSFwvNEZqa1o5N3VXT3FvTzUwSVVvNU5qOW9CekU4c2ZVaExsZkNBUFJyTlFMTjgzN2p6cHNadHZZYWFqTlpsZlwvekdCR3ZBcDBcL2xCZkRMbHlkdWF6N25neDJYVkZmNzJvNEhEZ2g4a3UyalZwcHdVQTBmVHFGRGtyNjNXQ2tRbTErNSttZHdVQkdURHJXeTFiQUJBVjBJSWpORmxWYzJidFwvd25LM2gwUUhCVEVvOFJhYlByYzNzcVR2M3RNQ0tTVG1WQ2hnaW82NjJ3dHF5eG1JbXZBWGhwTFdmWGJhK3JqZ3h1NHF0Q3VxZ1NNQWxCMDNGVHJRZXNjd1MzNGUrNjNOdTk1WmJkNFc0cmpCUmhCYU41R0h3aGRnVmk3d2ZLbHViZGJjWk1vVkwwU3JQMGJjRWFuZHYwOGY3MEtTcG9ySjFtSXNrV1wvWmFZbDgyUUF1NXYwUE1YY2Y0N3NLMW9rODhpNGFmYVNranhVclFUOVZ0VVorMFY1UitueVZQNlRLQUtQQT09IiwibWFjIjoiZjc1NTk3YWVlMTdhMzdhNWVkMzZhYzc2M2EzMmMzZmUxMDFhMjRlMzVmOGUxZTg2MjI1ODkwNzFlYzg5NDI3NyJ9
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      this.cartNotification.setActiveElement(document.activeElement);

      const submitButton = this.querySelector('[type="submit"]');

      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');

      
      let body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });
     
      const form = JSON.parse(serializeForm(this.form).replace("options[Length]", "length"));

      fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
          this.cartNotification.renderContents(parsedState);
          
          if (window.cartSettings.drawerCartEnabled === 'true') {

            // added for minicart
            document.querySelector('cart-items')?.classList.toggle('is-empty', parsedState.item_count === 0);
            document.getElementById('main-cart-items')?.classList.toggle('is-empty', parsedState.item_count === 0); document.getElementById('main-cart-footer')?.classList.toggle('is-empty', parsedState.item_count === 0);

            ToggleCart(true);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
        });
    }
  });
}

// Colour 2 - on hover, display text value under swatch

 document.addEventListener('DOMContentLoaded', function () {
  const colorLabels = document.querySelectorAll('label[data-color-value]');
  const hoverText = document.getElementById('color-hover-text');

  colorLabels.forEach(label => {
    label.addEventListener('mouseenter', function () {
      hoverText.textContent = this.getAttribute('data-color-value');
    });

    label.addEventListener('mouseleave', function () {
      // Keep the text as the selected input value if exists
      const selectedInput = document.querySelector('input[name="Colour 2"]:checked');
      if (selectedInput) {
        hoverText.textContent = selectedInput.value;
      } else {
        hoverText.textContent = '';
      }
    });

    label.addEventListener('click', function () {
      hoverText.textContent = this.getAttribute('data-color-value');
    });
  });

  // Ensure the selected value is displayed on load
  const selectedInput = document.querySelector('input[name="Colour 2"]:checked');
  if (selectedInput) {
    hoverText.textContent = selectedInput.value;
  }
});

